import { gql } from '@apollo/client';

const VisionandMissionQueryHi = gql`
  query MyQuery {
  nodeVissionAndMissions(first: 10, langcode: "hi") {
    nodes {
      __typename
      id
      title
      path
      bannerImage {
        url
      }
      visionAndMissionPoint {
        ... on ParagraphWorkingModelPoint {
          id
          pointsDescription
          pointsTitle
          iconWithWorkingModelPo {
            url
            alt
          }
        }
      }
    }
  }
}
`;

export default VisionandMissionQueryHi;
